import React from 'react';
import { ArrowRight, Star } from 'lucide-react';
// Eliminamos la importación del Button genérico porque usaremos un enlace <a> optimizado para Shopify

export function HeroSection() {
  return <section className="relative w-full min-h-[90vh] flex flex-col lg:flex-row overflow-hidden bg-[#FFFDD0]" data-id="element-23">
      {/* Left Content */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 py-12 lg:px-16 xl:px-24 z-10" data-id="element-24">
        <div className="max-w-xl mx-auto lg:mx-0" data-id="element-25">
          
          {/* Estrellas y Prueba Social */}
          <div className="flex items-center space-x-1 mb-6" data-id="element-26">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-[#D4AF37] fill-current" data-id="element-27" />)}
            <span className="text-xs font-medium tracking-widest uppercase ml-2 text-gray-500" data-id="element-28">
              Método Científicamente Comprobado
            </span>
          </div>

          {/* Titular Principal */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-medium text-gray-900 leading-tight mb-6" data-id="element-29">
            Rejuvenece y <span className="italic text-gray-600" data-id="element-30">Esculpe</span>{' '}
            Tu Rostro en 21 Días. <br data-id="element-31" />
            <span className="text-3xl md:text-4xl lg:text-5xl font-light block mt-2" data-id="element-32">
              Sin Agujas.
            </span>
          </h1>

          {/* Subtítulo Persuasivo */}
          <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed font-light font-body max-w-md" data-id="element-33">
            El método definitivo para levantar tus pómulos, definir tu mandíbula y borrar la "cara hinchada" con solo 10 minutos al día.
          </p>

          {/* Botón de Compra y Garantía */}
          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-34">
            {/* 🔴 ATENCIÓN: Aquí va tu Permalink de Shopify */}
            <a href="https://royswellness.com/cart/43340654968906:1" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-gray-900 border border-transparent rounded-full shadow-xl hover:bg-gray-800 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto" data-id="element-35">
              Comenzar mi Reto Hoy - $14.99
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-36" />
            </a>
            
            <div className="flex flex-col" data-id="element-37">
              <p className="text-xs text-gray-500 mt-2 sm:mt-0 italic font-medium" data-id="element-38">
                *Acceso inmediato de por vida
              </p>
              <p className="text-xs text-gray-400" data-id="element-39">
                Pago 100% Seguro
              </p>
            </div>
          </div>

          {/* Rostros de Prueba Social */}
          <div className="mt-12 flex items-center space-x-4 border-t border-gray-200 pt-6" data-id="element-40">
            <div className="flex -space-x-2" data-id="element-41">
              <img className="inline-block h-8 w-8 rounded-full ring-2 ring-white object-cover" src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Clienta feliz" data-id="element-42" />
              <img className="inline-block h-8 w-8 rounded-full ring-2 ring-white object-cover" src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Clienta feliz" data-id="element-43" />
              <img className="inline-block h-8 w-8 rounded-full ring-2 ring-white object-cover" src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Clienta feliz" data-id="element-44" />
            </div>
            <p className="text-sm text-gray-600 font-medium" data-id="element-45">
              Únete a +5,000 mujeres radiantes
            </p>
          </div>
        </div>
      </div>

      {/* Right Image Area */}
      <div className="w-full lg:w-1/2 bg-[#FADADD]/30 relative min-h-[50vh] lg:min-h-full flex items-center justify-center p-8 lg:p-16" data-id="element-46">
        <div className="absolute inset-0 bg-gradient-to-br from-[#FFFDD0] via-transparent to-transparent opacity-50 z-0" data-id="element-47"></div>

        {/* Contenedor de la Imagen del Mockup */}
        <div className="relative z-10 w-full max-w-lg transform transition-transform hover:scale-[1.02] duration-700" data-id="element-48">
          
          {/* 🔴 ATENCIÓN: Pega aquí el enlace de tu imagen generada */}
          <img src="https://images.unsplash.com/photo-1616683693504-3ea7e9ad6fec?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="FaceLift Natural Mockup" className="w-full h-auto rounded-2xl shadow-2xl object-cover border-4 border-white" data-id="element-49" />
          
          {/* Sombra realista debajo de la imagen */}
          <div className="absolute -bottom-10 left-10 right-10 h-8 bg-black/20 blur-2xl rounded-full" data-id="element-50"></div>
        </div>
      </div>
    </section>;
}